import React from "react";
import BaseInput from "../../../../components/BaseInput";
import BaseButton from "../../../../components/BaseButton";
import RecoverButton from "./components/RecoverButton";
import useController from "./controller";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function LoginForm() {
  const {
    onSubmitHandle,
    isFieldsEmpty,
    isLoginLoading,
    incorrectPairMessage,
    loginForm,
    handleChange,
  } = useController();
  const { t } = useTranslation();
  return (
    <div className="login-form">
      <form onSubmit={onSubmitHandle} action="" className="login-form__form">
        <BaseInput
          inputMode="email"
          value={loginForm.email}
          id="login-email"
          onChange={handleChange}
          name="email"
          label={t("email_label")}
          wrapperStyle="login-form__form__login"
          errorMessage={isFieldsEmpty ? t("login_page.fill_the_fields") : ""}
        />
        <BaseInput
          value={loginForm.password}
          onChange={handleChange}
          id="login-pass"
          name="password"
          type="password"
          label={t("password_label")}
          wrapperStyle="login-form__form__password"
          errorMessage={
            isFieldsEmpty
              ? t("login_page.fill_the_fields")
              : incorrectPairMessage
              ? incorrectPairMessage
              : ""
          }
        />
        <RecoverButton />
        <BaseButton
          type="submit"
          loading={isLoginLoading}
          className="login-form__log-in"
        >
          {t("login_acc")}
        </BaseButton>
      </form>
    </div>
  );
}
